import React from 'react';
import { CircularProgress, Box } from '@mui/material';

export default function LoadingIndicator() {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight={120}>
      <CircularProgress />
    </Box>
  );
} 